module.exports = __webpack_public_path__ + "static/media/vaccine-icon.4c9bdec8.svg";